rhm.klaviyo = (function (module, window) {
  'use strict';
  var settings, moneyFormat;
  var feedbackCloseEls, sideViewKlaviyoEl, sideViewEmailTriggerEls;
  var init;
  var closeSuccess, trackFormSubmit, oneSignalStatus;

  settings = {
    sideViewKlaviyo: '#sideViewKlaviyo',
    sideViewEmailTrigger: '.sideViewEmailTrigger',
    feedbackClose: '.successClose',
    sideViewKlaviyoForm: '.sideViewKlaviyoForm'
  };
  moneyFormat = Shopify.settings.money;

  sideViewKlaviyoEl = document.querySelector(settings.sideViewKlaviyo);
  sideViewEmailTriggerEls = document.querySelectorAll(settings.sideViewEmailTrigger);
  feedbackCloseEls = document.querySelectorAll(settings.feedbackClose);

  init = function () {
    feedbackCloseEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeSuccess();
      });
    });

    sideViewEmailTriggerEls.forEach(function (el) {
      el.addEventListener('click', function () {
        rhm.sideview.showSideView(sideViewKlaviyoEl);
      });
    });

    trackFormSubmit();
    cartTracking();
    identifyCustomer();
  };

  var identifyCustomer = () => {
    if ("customer" in window.theme) {
      klaviyo.identify({
        '$email': window.theme.customer.email,
        '$first_name': window.theme.customer.first_name,
        '$last_name': window.theme.customer.last_name
      }).then(() => {
        window.dataLayer.push({
          event: "klaviyo Indentify"
        });
      });
    }
  };


  var cartTracking = function () {
    if (document.getElementsByClassName('template-cart').length === 0) return;
    if (typeof klaviyoData !== 'undefined') abandoned_cart(klaviyoData);
  };


  trackFormSubmit = function () {
    /* Re-implement when Klaviyo subscription is wired via fetch. */
  };

  oneSignalStatus = function (subscribed, optedOut, pushEnabled) {
    window.klaviyo = window.klaviyo || [];
    window.klaviyo.push(['track', 'One Signal', {
      'visitedPage': true,
      'subscribed': subscribed || false,
      'optedOut': optedOut || false,
      'pushEnabled': pushEnabled || false,
    }]);
  };



  var buildProductItem = function (data) {
    var product = data.product;
    var price = (product.price) ? product.price : product.price_min;
    var compare_at_price = (product.compare_at_price) ? product.compare_at_price : product.compare_at_price_min;
    var image = product.images[0].includes('https:') ? product.images[0] : 'https:' + product.images[0];
    var item = {
      ProductName: product.title,
      ProductID: product.id,
      ImageURL: image,
      URL: `${window.theme.request.absolute_base_url}/${product.handle}`,
      Brand: product.vendor,
      Price: Shopify.formatMoneyWithoutCurrency(price),
      CompareAtPrice: Shopify.formatMoneyWithoutCurrency(compare_at_price)
    };

    if (typeof data.collections !== 'undefined') {
      item.Categories = data.collections;
    }
    if (typeof data.collection_image !== 'undefined') {
      item.CollectionImage = 'https:' + data.collection_image;
    }
    item.CollectionUrl = data.collection_url;

    if (typeof data.brand_image !== 'undefined') {
      item.BrandImage = data.brand_image;
    }
    return item;
  };

  var viewed_product = function (data) {
    if (typeof data !== 'undefined') {
      var item = buildProductItem(data);
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Viewed Product', item]);
      return;
    }
  };

  var viewed_page = function (data) {
    if (typeof data !== 'undefined') {
      var payload = {
        PageName: data
      };
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Viewed Page', payload]);



      return;
    }
  };

  var abandoned_cart = function (data) {
    if (typeof data !== 'undefined') {
      var item = buildProductItem(data);
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Added to Cart', item]);
    }
  };


  var wishlist_identify = () => {
    var parsedBrands = [];
    if (Shopify.customer && localStorage.iWishlistmain) {
      var iWishlistmain = JSON.parse(localStorage.getItem('iWishlistmain'));
      var parsedList = Object.keys(iWishlistmain).reduceRight(function (list, key) {
        list.push(key);
        return list;
      }, []);
      if (localStorage.iWishlistbrands) {
        parsedBrands = Object.keys(iWishlistBrands).reduceRight(function (list, key) {
          list.push(key);
          return list;
        }, []);
      }
      window.klaviyo.push(['identify', {
        '$email': Shopify.customer.email,
        '$wishlist': parsedList.slice(0, 10),
        '$wishlistBrands': parsedBrands.slice(0, 10)
      }]);
    }
  };

  var add_wishlist = function (data) {
    if (typeof data !== 'undefined') {
      var item = buildProductItem(data);
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'BLK | Added to Wishlist', item]);
      wishlist_identify();
    }
  };


  module = {
    init: init,
    wishlist_identify: wishlist_identify,
    add_wishlist: add_wishlist,
    viewed_product: viewed_product,
    viewed_page: viewed_page,
    abandoned_cart: abandoned_cart,
    oneSignalStatus: oneSignalStatus
  };

  return module;

}(rhm.klaviyo, window));

